export default __webpack_public_path__ + "resources/icons/d141-06b7.png";